import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { useEffect, useState } from "react";
import PurchaseService from "../../services/PurchaseOrder";
import UploadAndDownloadService from "../../services/uploadAndDownloadFile";
import $ from "jquery";

import MaterialTable from "material-table";
import DocumentService from "../../services/DocumentService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import DataTableProductsPurchase from "../../ui/DataTableProductsPurchase";
import { makeStyles } from "@material-ui/core";
import UtilsFormule from "../../utils/UtilsFormule";
import UploadFactureFile from "../../ui/UploadFactureFile";
import UploadFactureFileInPageDetailFactureAchat from "../../ui/UploadFactureFileInPageDetailFactureAchat";
const useStyles = makeStyles((theme) => ({
  input: {
    "&::placeholder": {
      fontStyle: "italic",
    },
  },
}));

const fmt = (v) => v != null ? parseFloat(Number(v).toFixed(3)) : "";

const ProductsByPurchaseDocument = () => {
  const classes = useStyles();
  const params = useParams();
  const getRef = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("ref") || sessionStorage.getItem("refDocument");
  };
  const getType = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("type") || sessionStorage.getItem("typeDocument");
  };
  const [documentProducts, setDocumentProducts] = useState([]);
  const [bdcLanguage, setBdcLanguage] = useState("fr");
  const [bdcGenerating, setBdcGenerating] = useState(false);
  const navigate = useNavigate();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [devisImageFile, setDevisImageFile] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [factureUploadInformation, setFactureUploadInformation] = useState({
    reference: "any",
  });

  const [onUploadFileFacture, setOnUploadFileFacture] = useState(false);

  $(".custom-file-input").on("change", function () {
    var fileNameTwo = $(this).val().split("\\").pop();
    $(this)
      .siblings(".custom-file-label")
      .addClass("selected")
      .html(fileNameTwo);
  });

  useEffect(() => {
    if (getType() === "devis") {
      DocumentService.getDevisByRef(
        getCurrentUserId(),
        getRef()
      )
        .then((response) => {
          console.log("response", response.data.success);
          setDocumentProducts(response.data.success);
        })
        .catch(() => {
          alert("problème de connexion");
        });
    } else if (getType() === "bdc") {
      PurchaseService.getBDCByRef(getRef())
        .then((response) => {
          setDocumentProducts(response.data.success);
        })
        .catch(() => {
          alert("problème de connexion");
        });
    } else if (getType() === "facture") {
      PurchaseService.getFactureByRef(getRef())
        .then((response) => {
          console.log("getFactureByRef", response.data.success);
          setDocumentProducts(response.data.success);
        })
        .catch(() => {
          alert("problème de connexion");
        });
    } else if (getType() === "po") {
      PurchaseService.getPOByRef(getRef())
        .then((response) => {
          console.log(response);

          setDocumentProducts(response.data.success);
        })
        .catch(() => {
          alert("problème de connexion");
        });
    } else if (params.type === "documentHistory") {
      PurchaseService.getPurchaseHistoryByWarehouse(
        params.documentReference,
        params.idWarehouse
      )
        .then((response) => {
          setDocumentProducts(response.data.success);
        })
        .catch(() => {
          alert("problème de connexion");
        });
    }
  }, []);

  useEffect(() => {
    if (documentProducts && documentProducts.language) {
      setBdcLanguage(documentProducts.language);
    }
  }, [documentProducts]);

  const onGenerateBdcHandler = () => {
    if (bdcGenerating) return;
    setBdcGenerating(true);
    PurchaseService.generateBD(getRef(), bdcLanguage)
      .then((response) => {
        const order = response.data && response.data.bonDeCommande;
        if (order && order.path) {
          setDocumentProducts({ ...documentProducts, path: order.path, language: order.language || bdcLanguage });
          onShowFileInOtherWizndowHandler(order.path);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : le bon de commande n'a pas pu être généré");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il y a un problème de connexion");
      })
      .finally(() => setBdcGenerating(false));
  };

  const bdcFile = () => {
    const hasFile =
      documentProducts.path &&
      documentProducts.path !== "any" &&
      documentProducts.path !== "string" &&
      documentProducts.path !== "String";
    return (
      <section className="content-header">
        <div className="container-fluid">
          <div className="card card-dark">
            <div className="card-header">
              <h3 className="card-title">
                <i className="fas fa-file-pdf mr-2"></i>
                Fichier du bon de commande {documentProducts.ref}
              </h3>
            </div>
            <div className="card-body">
              <div className="row align-items-end">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="bdcLanguage">Langue du fichier</label>
                    <select
                      id="bdcLanguage"
                      className="form-control"
                      value={bdcLanguage}
                      onChange={(e) => setBdcLanguage(e.target.value)}
                    >
                      <option value="fr">Français</option>
                      <option value="en">English</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="form-group">
                    <button
                      type="button"
                      className="btn btn-dark mr-2"
                      disabled={bdcGenerating}
                      onClick={onGenerateBdcHandler}
                    >
                      <i className="fas fa-cogs mr-1"></i>
                      {hasFile ? "Régénérer le bon de commande" : "Générer le bon de commande"}
                    </button>
                    {hasFile && (
                      <button
                        type="button"
                        className="btn btn-outline-dark"
                        onClick={() => onShowFileInOtherWizndowHandler(documentProducts.path)}
                      >
                        <i className="fas fa-eye mr-1"></i>Voir le fichier
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <small className="text-muted">
                {hasFile
                  ? "Un fichier existe déjà : le régénérer le remplace, dans la langue choisie."
                  : "Aucun fichier pour ce bon de commande. Le fichier généré suit la langue choisie (libellés, noms, descriptions et notes des produits)."}
              </small>
            </div>
          </div>
        </div>
      </section>
    );
  };

  const onValidateDevisHandler = (ref) => {
    sessionStorage.setItem("refDevis", ref);
    // sessionStorage.setItem("typeToTax", "Devis");
    navigate("/validateDevisBDC");
  };
  const onValidateBDCHandler = (ref) => {
    sessionStorage.setItem("refBDC", ref);
    navigate("/validateBDCFacture");
  };

  const onRecieveBDCHandler = (ref) => {
    sessionStorage.setItem("refBDC", ref);
    navigate("/receiveProducts");
  };
  const onUploadFileHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setDevisImageFile(e.target.files[0]);
    }
  };
  const onShowFileInOtherWizndowHandler = (path) => {
    UploadAndDownloadService.downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };
  const devisFile = () => {
    if (
      getType() === "devis" &&
      documentProducts.path === "any"
    ) {
      return (
        <section className="content-header">
          <div className="container-fluid">
            <div class="card card-dark">
              <div class="card-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div class="form-group">
                      <label for="exampleInputFile">Devis </label>
                      <div class="input-group">
                        <div class="custom-file">
                          <input
                            accept="application/pdf, .jpg, .jpeg, .png"
                            type="file"
                            className="custom-file-input"
                            id="exampleInputFile"
                            onChange={onUploadFileHandler}
                          />
                          <label
                            class="custom-file-label"
                            for="exampleInputFile"
                          >
                            Entrer le fichier de devis
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div className="row">
                  <div className="col-sm-9"></div>
                  <div className="col-sm-3">
                    <button
                      class="btn btn-dark btn-sm float-right"
                      onClick={onUploadFileToBackendHandler}
                    >
                      Ajouter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    } else {
      return (
        <section className="content-header">
          <div className="container-fluid">
            <section className="content-header">
              <div className="container-fluid">
                <div class="card card-dark">
                  <div class="card-body">
                    <div className="row">
                      <div className="col-md-10">
                        <h5 class="card-title">
                          Devis: {documentProducts.ref}
                        </h5>
                      </div>
                      <div className="col-md-2">
                        <button
                          style={{ width: 40 }}
                          class="btn bg-gray btn-sm "
                          onClick={() =>
                            onShowFileInOtherWizndowHandler(
                              documentProducts.path
                            )
                          }
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      );
    }
  };

  const onUploadFileToBackendHandler = () => {
    if (devisImageFile.length === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :aucun fichier ");
    } else {
      // console.log(devisUploadInformation);
      const uploadData = new FormData();
      uploadData.append("picture", devisImageFile);

      UploadAndDownloadService.uploadFile(
        "/retail/uploadFile/uploadFile/devis",
        uploadData
      )
        .then((response) => {
          if (response.data.success) {
            console.log(response.data.success);

            PurchaseService.updateDevisPathFile(
              documentProducts.reference,
              response.data.success
            )
              .then((res) => {
                if (res.data.success) {
                  console.log(res.data.success);
                } else {
                  setOpenErrorAlert(true);
                  setErrorAlertText("Erreur : il ya un erreur");
                }
              })
              .catch(() => {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : il ya un probléme de connection");
              });
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un erreur  ");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });

      setTimeout(window.location.reload(false), 5000);
    }
  };

  const onUploadFileHandlerFacture = ( reference) => {
    setFactureUploadInformation({
      reference: reference,
    });
    setOnUploadFileFacture(true);
  };
  return (
    <div className="content-wrapper document-details" style={{ marginTop: "0" }}>
      <style>{`
        .document-details .card.card-dark {
          background: #fff;
          border-radius: 8px;
          border-top: 3px solid #343a40;
          box-shadow: 0 1px 6px rgba(0,0,0,.08);
        }
        .document-details .card.card-dark .card-title {
          font-weight: 600;
          color: #343a40;
        }
        .document-details .card.card-dark .card-header {
          background: #fff;
          color: #343a40;
        }
        .document-details .info-box {
          background: #fff !important;
          color: #343a40 !important;
          border-radius: 8px;
          border-left: 4px solid #343a40;
          box-shadow: 0 1px 6px rgba(0,0,0,.08);
        }
        .document-details .info-box .info-box-icon {
          background: #343a40 !important;
          color: #fff !important;
          border-radius: 8px;
          margin: 8px 0 8px 8px;
          min-height: 54px;
          height: 54px;
          width: 54px;
        }
        .document-details .info-box .info-box-text {
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.03em;
          color: #6c757d !important;
        }
        .document-details .info-box .info-box-number {
          font-size: 1.15rem;
          font-weight: 700;
          color: #343a40 !important;
        }
        .document-details .info-box .progress {
          display: none;
        }
        .document-details .info-box .progress-description {
          color: #6c757d !important;
          font-size: 0.8rem;
        }
      `}</style>
      <section className="content-header">
        <div className="container-fluid">
          {getType() === "devis" && (
            <>
              <section className="content-header">
                <div className="container-fluid">
                  <div class="card card-dark">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-10">
                          <h5 class="card-title">
                            Devis: {documentProducts.ref}
                          </h5>
                        </div>
                        <div className="col-md-2">
                          {" "}
                          <i class="fa-regular fa-calendar-days"></i> Date:{" "}
                          {UtilsFormule.formatDate(documentProducts.createionDate)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <div className="row">
                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-user"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Fournisseur</span>
                      <span className="info-box-number">
                        {documentProducts?.supplier?.title}
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      {/* <span className="progress-description">
                        {fmt(documentProducts.htPrice)} DNT prix HT
                      </span> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-dollar-sign"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Prix TTC</span>
                      <span className="info-box-number">
                        {fmt(documentProducts.finalPriceTt !== null ? documentProducts.finalPriceTt : documentProducts.priceTT)} DNT

                        {/* {documentProducts.ttPrice} DNT */}
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {fmt(documentProducts.finalPriceHT !== null ? documentProducts.finalPriceHT : documentProducts.buyinfPrice)} DNT prix HT
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark ">
                    <span className="info-box-icon">
                      <i class="fas fa-chart-line"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Prix d'achat</span>
                      <span className="info-box-number">
                        {fmt(documentProducts.buyinfPrice)} DNT
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      {documentProducts.discountPercentage !== 0 && (
                        <span className="progress-description">
                          Promotion de{documentProducts.discountPercentage}%{" "}
                        </span>
                      )}
                      {documentProducts.discountPercentage === 0 && (
                        <span className="progress-description">
                          {fmt(documentProducts.htPrice)} DNT prix HT
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box  bg-black">
                    <span className="info-box-icon">
                      <i class="fas fa-shopping-cart"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Produits</span>

                      {documentProducts.purchases && (
                        <span className="info-box-number">
                          {documentProducts.purchases.length}{" "}
                        </span>
                      )}
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      {documentProducts.purchases && (
                        <span className="progress-description">
                          {documentProducts.purchases.length}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {devisFile()}
              <div className="row">
                <div className="col-md-10 col-sm-6 col-12"></div>
                <div className="col-md-2 col-sm-6 col-12">
                  {" "}
                  <button
                    class="btn btn-dark btn-sm float-right"
                    onClick={() =>
                      onValidateDevisHandler(
                        getRef()
                      )
                    }
                  >
                    <i class="fas fa-check"></i>
                    Bon de commande
                  </button>
                </div>
              </div>
            </>
          )}
          {getType() === "bdc" && (
            <>
              <section className="content-header">
                <div className="container-fluid">
                  <div class="card card-dark">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-10">
                          <h5 class="card-title">
                            Bon de commande: {documentProducts.ref}
                          </h5>
                        </div>
                        <div className="col-md-2">
                          {" "}
                          <i class="fa-regular fa-calendar-days"></i> Date:{" "}
                          {UtilsFormule.formatDate(documentProducts.createionDate)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <div className="row">
                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-user"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Fournisseur</span>
                      <span className="info-box-number">
                        {documentProducts?.supplier?.title}
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      {/* <span className="progress-description">
                        {fmt(documentProducts.htPrice)} DNT prix HT
                      </span> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-dollar-sign"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Prix TTC</span>
                      <span className="info-box-number">
                        {fmt(documentProducts.finalPriceTt !== null ? documentProducts.finalPriceTt : documentProducts.priceTT)} DNT
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {fmt(documentProducts.finalPriceHT !== null ? documentProducts.finalPriceHT : documentProducts.buyinfPrice)} DNT prix HT
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark ">
                    <span className="info-box-icon">
                      <i class="fas fa-chart-line"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Prix d'achat</span>
                      <span className="info-box-number">
                        {fmt(documentProducts.finalPriceHT !== null ? documentProducts.finalPriceHT : documentProducts.buyinfPrice)} DNT prix HT
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      {documentProducts.discountPercentage !== 0 && (
                        <span className="progress-description">
                          Promotion de{documentProducts.discountPercentage}%{" "}
                        </span>
                      )}
                      {documentProducts.discountPercentage === 0 && (
                        <span className="progress-description">
                          {fmt(documentProducts.htPrice)} DNT prix HT
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box  bg-black">
                    <span className="info-box-icon">
                      <i class="fas fa-shopping-cart"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Produits</span>

                      {documentProducts.purchases && (
                        <span className="info-box-number">
                          {documentProducts.purchases.length}{" "}
                        </span>
                      )}
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      {documentProducts.purchases && (
                        <span className="progress-description">
                          {documentProducts.purchases.length}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {bdcFile()}
              <div className="row">
                <div className="col-md-9 col-sm-6 col-12"></div>
                <div className="col-md-2 col-sm-6 col-12">
                  <button
                    class="btn btn-dark btn-sm float-right"
                    onClick={() =>
                      onRecieveBDCHandler(getRef())
                    }
                  >
                    <i class="fas fa-check"></i>
                    Recevoir tous les produits
                  </button>
                </div>
                <div className="col-md-1 col-sm-6 col-12">
                  <button
                    class="btn btn-dark btn-sm float-right"
                    onClick={() =>
                      onValidateBDCHandler(
                        getRef()
                      )
                    }
                  >
                    <i class="fas fa-check"></i>
                    Facture
                  </button>
                </div>
              </div>
            </>
          )}
          {getType() === "facture" && (
            <>
              <section className="content-header">
                <div className="container-fluid">
                  <div className="card card-dark">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fas fa-file-invoice mr-2"></i>
                        Facture :&nbsp;<strong>{documentProducts.ref}</strong>
                      </h3>
                      <div className="card-tools d-flex align-items-center">
                        <span className="badge badge-light mr-3" style={{ fontSize: "0.85rem", padding: "6px 10px" }}>
                          <i className="fas fa-calendar-alt mr-1"></i>
                          {UtilsFormule.formatDate(documentProducts.createionDate)}
                        </span>
                        <button
                          className="btn btn-sm btn-outline-light"
                          title="Changer le document de la facture"
                          onClick={() => onUploadFileHandlerFacture(documentProducts.ref)}
                        >
                          <i className="fas fa-upload mr-1"></i>
                          Changer le document
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <div className="row">
                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-user"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Fournisseur</span>
                      <span className="info-box-number">
                        {documentProducts?.supplier?.title}
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-dollar-sign"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Prix TTC</span>
                      <span className="info-box-number">

                        {fmt(documentProducts.finalPriceTt !== null ? documentProducts.finalPriceTt : documentProducts.priceTT)} DNT
                        {/* {documentProducts.priceTT} DNT */}
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {fmt(documentProducts.finalPriceHT !== null ? documentProducts.finalPriceHT : documentProducts.buyinfPrice)} DNT prix HT

                        {/* {fmt(documentProducts.buyinfPrice)} DNT prix HT */}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark ">
                    <span className="info-box-icon">
                      <i class="fas fa-chart-line"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Prix d'achat</span>
                      <span className="info-box-number">
                        {fmt(documentProducts.priceTT)} DNT
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      {documentProducts.discountPercentage !== 0 && (
                        <span className="progress-description">
                          Promotion de{documentProducts.discountPercentage}%{" "}
                        </span>
                      )}
                      {documentProducts.discountPercentage === 0 && (
                        <span className="progress-description">
                          {fmt(documentProducts.buyinfPrice)} DNT prix HT
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box  bg-black">
                    <span className="info-box-icon">
                      <i class="fas fa-shopping-cart"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Produits</span>

                      {documentProducts.purchases && (
                        <span className="info-box-number">
                          {documentProducts.purchases.length}{" "}
                        </span>
                      )}
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      {documentProducts.purchases && (
                        <span className="progress-description">
                          {documentProducts.purchases.length}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-10 col-sm-6 col-12"></div>
                <div className="col-md-2 col-sm-6 col-12">
                  <button
                    class="btn btn-dark btn-sm float-right"
                    onClick={() =>
                      onRecieveBDCHandler(getRef())
                    }
                  >
                    <i class="fas fa-check"></i>
                    Recevoir tous les produits
                  </button>
                </div>
              </div>
            </>
          )}
          {getType() === "po" && (
            <div className="row">
              <div className="col-md-4 col-sm-6 col-12">
                <div className="info-box bg-gray ">
                  <span className="info-box-icon">
                    <i class="fas fa-dollar-sign"></i>{" "}
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Prix TTC</span>
                    <span className="info-box-number">
                      {fmt(documentProducts.ttPrice)} DNT
                    </span>
                    <div className="progress">
                      <div className="progress-bar" style={{ width: "70%" }} />
                    </div>
                    <span className="progress-description">
                      {fmt(documentProducts.buyingPrice)} DNT prix HT
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 col-12">
                <div className="info-box bg-gray-dark ">
                  <span className="info-box-icon">
                    <i class="fas fa-chart-line"></i>{" "}
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Prix d'achat</span>
                    <span className="info-box-number">
                      {fmt(documentProducts.buyingPrice)} DNT
                    </span>
                    <div className="progress">
                      <div className="progress-bar" style={{ width: "70%" }} />
                    </div>
                    {documentProducts.discountPercentage !== 0 && (
                      <span className="progress-description">
                        Promotion de{documentProducts.discountPercentage}%{" "}
                      </span>
                    )}
                    {documentProducts.discountPercentage === 0 && (
                      <span className="progress-description">
                        {fmt(documentProducts.buyingPrice)} DNT prix HT
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 col-12">
                <div className="info-box  bg-black">
                  <span className="info-box-icon">
                    <i class="fas fa-shopping-cart"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Produits</span>

                    {documentProducts.purchases && (
                      <span className="info-box-number">
                        {documentProducts.purchases.length}{" "}
                      </span>
                    )}
                    <div className="progress">
                      <div className="progress-bar" style={{ width: "100%" }} />
                    </div>
                    {documentProducts.purchases && (
                      <span className="progress-description">
                        {documentProducts.purchases.length}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <br />
        {onUploadFileFacture && (
          <UploadFactureFileInPageDetailFactureAchat
            setOnUploadFile={setOnUploadFileFacture}
            factureUploadInformation={factureUploadInformation}
          />
        )}
        {documentProducts.purchases && (
          <DataTableProductsPurchase
            listProduits={documentProducts.purchases}
          />
        )}
      </section>
    </div>
  );
};
export default ProductsByPurchaseDocument;
